import { render, staticRenderFns } from "./IconLicencas.vue?vue&type=template&id=315b6e99"
import script from "./IconLicencas.vue?vue&type=script&lang=js"
export * from "./IconLicencas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports